/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseStoreStatus } from '../../models/api-response-store-status';

export interface GetStoreStatus$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  refPhoneCompany?: string;
}

export function getStoreStatus(http: HttpClient, rootUrl: string, params: GetStoreStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseStoreStatus>> {
  const rb = new RequestBuilder(rootUrl, getStoreStatus.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.query('refPhoneCompany', params.refPhoneCompany, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseStoreStatus>;
    })
  );
}

getStoreStatus.PATH = '/v1/api/ui/company/store-status';
